/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import logo from "../../../_metronic/assets/logo/logo.png";
import authBackground from "../../../_metronic/assets/logo/background.png";
import "./auth-layout.scss";

const FEATURE_LABEL_BREAKS = {
  "F&I Sell-Through": ["F&I", "Sell-Through"],
  "Turn Cost Into Profit": ["Turn Cost", "Into Profit"],
};

const FEATURES = [
  {
    label: "VIN Pairing",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="4" width="1.6" height="16" fill="currentColor" />
        <rect x="5.5" y="4" width="1" height="16" fill="currentColor" />
        <rect x="7.5" y="4" width="2.4" height="16" fill="currentColor" />
        <rect x="11" y="4" width="1.1" height="16" fill="currentColor" />
        <rect x="13.1" y="4" width="0.8" height="16" fill="currentColor" />
        <rect x="14.8" y="4" width="2.6" height="16" fill="currentColor" />
        <rect x="18.3" y="4" width="1.1" height="16" fill="currentColor" />
        <rect x="20.4" y="4" width="1.6" height="16" fill="currentColor" />
      </svg>
    ),
  },
  {
    label: "Inventory Tracking",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
          x="2"
          y="3"
          width="20"
          height="13"
          rx="1.5"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <path d="M9 20.5h6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M12 16v4.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    label: "F&I Sell-Through",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <circle cx="6.2" cy="7.2" r="2.4" />
        <path d="M1.5 18.8c0-3.4 2.1-5.5 4.7-5.5s4.7 2.1 4.7 5.5" />
        <circle cx="17.8" cy="7.2" r="2.4" />
        <path d="M13.1 18.8c0-3.4 2.1-5.5 4.7-5.5s4.7 2.1 4.7 5.5" />
        <circle cx="12" cy="6.4" r="2.8" />
        <path d="M6.8 18.8c0-3.9 2.4-6.2 5.2-6.2s5.2 2.3 5.2 6.2" />
      </svg>
    ),
  },
  {
    label: "Turn Cost Into Profit",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 17.5V14M8.5 17.5V11.5M13 17.5V9M17.5 17.5V6.5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
        <path d="M3.5 10l4.2-4.2 3.6 2.5 8.2-7.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15.2 1.2h4.6v4.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
];

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById("root");
    if (root) {
      root.style.height = "100%";
    }
    return () => {
      if (root) {
        root.style.height = "auto";
      }
    };
  }, []);

  return (
    <div className="kp-auth">
      <div
        className="kp-auth-photo"
        style={{ backgroundImage: `url(${authBackground})` }}
        aria-hidden="true"
      />

      <div className="kp-auth-frame">
        <section className="kp-auth-brand">
          <div className="kp-auth-logo">
            <img src={logo} alt="Key Patrol" />
          </div>

          <h1 className="kp-auth-headline">
            <span className="kp-auth-headline-accent">DEALER</span>
            <span className="kp-auth-headline-dark">PORTAL</span>
          </h1>

          <p className="kp-auth-tagline">
            One place to pair VINs, track inventory, and support F&amp;I
            sell-through.
          </p>
          <p className="kp-auth-support">Built for dealerships. Designed for control.</p>

          <div className="kp-auth-features">
            {FEATURES.map((feature) => (
              <div className="kp-auth-feature" key={feature.label}>
                <span className="kp-auth-feature-icon">{feature.icon}</span>
                <span className="kp-auth-feature-label">
                  {FEATURE_LABEL_BREAKS[feature.label] ? (
                    <>
                      {FEATURE_LABEL_BREAKS[feature.label][0]}
                      <br />
                      {FEATURE_LABEL_BREAKS[feature.label][1]}
                    </>
                  ) : (
                    feature.label
                  )}
                </span>
              </div>
            ))}
          </div>
        </section>

        <section className="kp-auth-panel">
          <Outlet />
        </section>
      </div>
    </div>
  );
};

export { AuthLayout };
